import script from "./Calc.vue?vue&type=script&setup=true&lang=js"
export * from "./Calc.vue?vue&type=script&setup=true&lang=js"

import "./Calc.vue?vue&type=style&index=0&id=025b89a3&lang=scss"

const __exports__ = script;

export default __exports__